<!-- this component is used in both My Leads and Available Leads -->
<template>
	<QSubmenu
		base-url="/leads"
		:title="title"
		:titlelink="titlelink"
		:buttons="buttons"
		:submenu="submenu"
		class="q-stycky"
	/>
</template>
<script>
import QSubmenu from "@/components/navigation/Submenus/QSubmenu.vue";

const buttons = [
	{
		label: "HQ How-to",
		to: "/page/hq-how-to",
		icon: "fas fa-arrow-alt-circle-right",
	},
	{
		label: "Switchboard",
		to: "/page/switchboard-sites",
		icon: "fas fa-arrow-alt-circle-right",
	},
	{
		label: "Power Dialer",
		to: "/page/power-dialer",
		icon: "fas fa-arrow-alt-circle-right",
	},
	{
		label: "Virtual Assistant",
		to: "/page/virtual-assistant",
		icon: "fas fa-arrow-alt-circle-right",
	},
	{
		label: "Virtual Mentor",
		to: "/page/virtual-mentor",
		icon: "fas fa-arrow-alt-circle-right",
	},
];

export default {
	components: {
		QSubmenu,
	},
	props: {
		hasDemo: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			title: "Quility Tech",
			titlelink: [],
			buttons,
		};
	},
	computed: {
		submenu: function () {
			var submenu = [
				{
					label: "Help",
					to: "/support",
				},
			];
			if (this.hasDemo) {
				submenu.push({
					label: "Start Demo",
					fun: () => {
						this.$emit("demo");
					},
				});
			}
			return submenu;
		},
	},
};
</script>
<style></style>
